<template>
  <v-container class="academic-dialog">
    <v-dialog persistent v-model="academicsDialog" max-width="800px">
      <v-card flat class="academic-dialog">
        <v-toolbar color="primary" dark
          >{{ isEdit ? "Edit" : "Add" }} Qualification</v-toolbar
        >
        <v-spacer></v-spacer>
        <v-card-title class="d-flex justify-space-between"> </v-card-title>
        <v-card-text>
          <v-form v-model="isValid" ref="academicForm" @submit.prevent="false">
            <v-row>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-text-field
                  v-model="formData.institution"
                  placeholder="Select Institution"
                  label="Institution"
                  :rules="[rules.required]"
                  dense
                  persistent-placeholder
                  color="primary"
                  outlined
                  prepend-inner-icon="business"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-select
                  v-model="formData.levels"
                  placeholder="Select Education Level"
                  label="Education level"
                  :items="levels"
                  :item-text="(item) => item.description"
                  :item-value="(item) => item.code"
                  dense
                  :rules="[rules.required]"
                  color="primary"
                  persistent-placeholder
                  outlined
                  prepend-inner-icon="school"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-select
                  v-model="formData.certificateAwarded"
                  placeholder="Select Certification"
                  label="Certification"
                  :items="certifications"
                  :item-text="(item) => item.description"
                  :item-value="(item) => item.code"
                  dense
                  :rules="[rules.required]"
                  color="primary"
                  persistent-placeholder
                  outlined
                  prepend-inner-icon="school"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-text-field
                  v-model="formData.areaOfSpecialization"
                  placeholder="Course Title"
                  label="Course Title"
                  :rules="[rules.required]"
                  dense
                  persistent-placeholder
                  color="primary"
                  outlined
                  prepend-inner-icon="assignment"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-text-field
                  v-model="formData.grade"
                  placeholder="Select Grade Attained"
                  label="Grade Attained"
                  :rules="[rules.required]"
                  dense
                  color="primary"
                  persistent-placeholder
                  outlined
                  prepend-inner-icon="mdi-medal-outline"
                  clearable
                />
              </v-col>
            </v-row>
            <v-row> </v-row>
            <div class="my-4">Certificate Attachment</div>
            <v-row>
              <v-col cols="12" md="12" sm="12" xs="12">
                <FileUpload
                  :Accept="'application/pdf'"
                  :IsImage="false"
                  :Icon="'cloud_upload'"
                  :Outlined="true"
                  @updateFile="uploadFile"
                  :status="fileStatus"
                  :showFile="formData.base64Attachment.length !== 0"
                  :base64File="formData.base64Attachment"
                  :FileName="
                    academic.lineNo !== undefined
                      ? `${academic.profileID}-${academic.lineNo}`
                      : ''
                  "
                  :displayOptions="displayOptions"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            class="white--text mx-2"
            @click="closeDialog"
          >
            <v-icon>cancel</v-icon>
            Cancel
          </v-btn>
          <v-btn color="primary" @click="saveAcademic">
            <v-icon> {{ isEdit ? "edit" : "save" }}</v-icon>
            {{ isEdit ? "Edit" : "Submit" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import FileUpload from "../../dashboard/components/FileUpload.vue";
import AuthService from "../../dashboard/modules/auth/AuthService";
import helpers from "../../dashboard/utils/helpers/helper.js";
export default {
  name: "academicsDialog",
  components: { FileUpload },
  props: {
    dialogbox: Boolean,
    isEdit: Boolean,
    levels: Array,
    certifications: Array,
    updateAttachment: Boolean,
  },
  data: function () {
    return {
      isValid: false,
      formData: {
        institution: "",
        levels: "",
        areaOfSpecialization: "",
        certificateAwarded: "",
        qualificationCode: "",
        base64Attachment: "",
      },
      displayOptions: { elevation: "3", width: "60ch", isEdit: true },
      fileStatus: "default",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getacademics", {
          lineNo: to.query.edit.toString(),
        });
      }
    });
  },
  watch: {
    academic() {
      this.formData = { ...this.academic };
      this.academicsDialog = true;
    },
  },
  computed: {
    academicsDialog: {
      get() {
        return this.dialogbox;
      },
      set(value) {
        this.setAcademicsDialog(value);
      },
    },
    today() {
      return new Date().toJSON().slice(0, 10);
    },
    academic() {
      return this.$store.getters["Profile/academicsGetters"]("academic");
    },
    certificationClass() {
      return this.$store.getters["Profile/setupGetter"]("certificationClass");
    },
    qualificationCodes() {
      return this.$store.getters["Profile/setupGetter"]("qualificationCodes");
    },
  },
  methods: {
    closeDialog() {
      this.$refs.academicForm.reset();
      this.academicsDialog = false;
      this.formData.base64Attachment = "";
      Event.$emit("clearUpload");
    },
    saveAcademic() {
      if (!this.isValid) {
        this.$refs.academicForm.validate();
      } else if (this.formData.base64Attachment.length === 0) {
        Event.$emit("ApiError", "Certificate Attachment is required");
        this.fileStatus = "error";
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        this.isEdit
          ? this.$store.dispatch("Profile/editacademics", { ...this.formData })
          : this.$store.dispatch("Profile/submitacademics", {
              ...this.formData,
            });
        this.academicsDialog = false;
        this.$refs.academicForm.reset();
        this.formData.base64Attachment = "";
        Event.$emit("clearUpload");
      }
    },
    setAcademicsDialog(value) {
      this.$emit("setAcademicsDialog", value);
    },
    uploadFile: async function (value) {
      if (value.file.name !== undefined) {
        if (value.file.size > 200000000) {
          this.fileStatus = "error";
        } else {
          this.fileStatus = "success";
          this.formData.base64Attachment = await helpers.toBase64(value.file);
          this.formData.base64Attachment =
            this.formData.base64Attachment.split(",")[1];
        }
      } else {
        this.formData.base64Attachment = "";
      }
    },
  },
};
</script>
<style scoped>
.academic-dialog {
  font-family: "PT Sans Caption", sans-serif;
  cursor: progress;
}
</style>
